var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 169.997,
    height: 169.997,
    viewBox: "0 0 169.997 169.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2d3c6b;}.b{fill:#6dcef8;}.c{fill:#c3e678;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.75 -1.747)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 84.998,
    cy: 84.998,
    r: 84.998,
    transform: "translate(1.75 1.747)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 9.899,
    cy: 9.899,
    r: 9.899,
    transform: "translate(76.849 76.846)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.015 13.023)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M151.4,42.931a2.392,2.392,0,1,0-4.384,1.912A68.953,68.953,0,1,1,14.779,72.224a2.39,2.39,0,1,0-4.779,0A73.733,73.733,0,1,0,151.4,42.936Z",
    transform: "translate(-10 1.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.736,57.585a2.388,2.388,0,0,0,3.14-1.24,68.883,68.883,0,0,1,110.29-23L118.074,44.441a53.236,53.236,0,0,0-84.561,60.938,2.392,2.392,0,0,0,4.369-1.95,48.464,48.464,0,1,1,92.694-22.091H112.529a2.39,2.39,0,0,0-2.389,2.394,27.972,27.972,0,0,1-47.7,19.853c-.023-.023-.038-.052-.061-.075s-.052-.038-.075-.061a27.992,27.992,0,0,1,39.656-39.516,2.39,2.39,0,0,0,3.379-3.379,32.753,32.753,0,0,0-47.949,44.568L44.558,117.956l-.014.016-.018.014a2.391,2.391,0,0,0,0,3.379,53.226,53.226,0,0,0,76.923-73.545L134.268,35a2.387,2.387,0,0,0,0-3.378A73.688,73.688,0,0,0,14.495,54.44a2.392,2.392,0,0,0,1.241,3.145ZM82.163,132.2a48.1,48.1,0,0,1-32.527-12.562L60.767,108.51a32.719,32.719,0,0,0,54.058-22.393h15.752A48.533,48.533,0,0,1,82.163,132.2Z",
    transform: "translate(-8.43 -10.005)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaze);
export default __webpack_public_path__ + "static/media/maze.db2d920ffab9c90ffeec23bdce9ec34e.svg";
export { ForwardRef as ReactComponent };